module.exports = __webpack_public_path__ + "static/media/send.327b0574.svg";